var map = {
	"./Girls_Rising.svg": 8336,
	"./Karen_Organization_of_San_Diego.svg": 9538,
	"./La_Chula_Crew_Foundation.svg": 3284,
	"./North_County_LGBTQ_Resource_Center.svg": 2920,
	"./Refugee_Health_Alliance.svg": 4622,
	"./Transfamily_Support_Services.svg": 140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8594;